import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {PreFilterInteractivesService} from "../../../api/services/pre-filter-interactives.service";
import {PreFilterKeys} from "../../../api/models/pre-filter-keys";
import {ConfirmDialogComponent} from "../../confirm-dialog/confirm-dialog.component";
import {DialogResultType} from "../../DialogResult";
import {MessageDialogComponent} from "../../message-dialog/message-dialog.component";
import {PreFilterKeysModel} from "../../../api/models/pre-filter-keys-model";
import {PreFilterHierarchyMaps} from "../../../api/models/pre-filter-hierarchy-maps";
import {finalize} from "rxjs/operators";

export interface EditInteractivePreFiltersDialogData {
  interactiveId: number;
}

@Component({
  selector: 'app-edit-interactive-pre-filters-dialog',
  templateUrl: './edit-interactive-pre-filters-dialog.component.html',
  styleUrls: ['./edit-interactive-pre-filters-dialog.component.css']
})
export class EditInteractivePreFiltersDialogComponent implements OnInit {

  preFilterData: PreFilterKeysModel[];
  selectedPreFilter: PreFilterKeysModel;
  allKeys: string;

  public selectedIndex: number = 0;

  public preFilterName: string = '';
  public preFilterDax: string = '';
  public preFilterType: number = 0;

  public preFilterHierarchyMaps: PreFilterHierarchyMaps[] = [];

  public hierarchyDaxField: string = '';
  public hierarchyLevel: number = 1;

  // New
  // Edit
  public editMode = 'New';


  constructor(
    public dialogRef: MatDialogRef<EditInteractivePreFiltersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditInteractivePreFiltersDialogData,
    private preFilterService: PreFilterInteractivesService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.loadPreFilters().then();
  }

  loadPreFilters(): Promise<PreFilterKeys[]> {
    return new Promise<PreFilterKeys[]>((success, failed) => {
      this.preFilterService.preFilterInteractivesGetInteractivePreFilterKeys(this.data.interactiveId).subscribe(result => {
        this.preFilterData = result;
        success(result);
      });
    })
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  selectFilterKey(preFilterKeyId: number) {
    this.selectedPreFilter = this.preFilterData.find(x => x.preFilterKeyId === preFilterKeyId);
  }

  editFilterKey(preFilterKeyId: number) {
    this.selectedPreFilter = this.preFilterData.find(x => x.preFilterKeyId == preFilterKeyId);
    this.preFilterName = this.selectedPreFilter.name;
    this.preFilterDax = this.selectedPreFilter.daxName;
    this.preFilterType = this.selectedPreFilter.keyType;
    this.editMode = 'Edit';
    let keyValues = '';
    let isFirst = true;

    if (this.selectedPreFilter.keyType === 0) {
      this.selectedPreFilter.flatValues.forEach(x => {
        if (isFirst) {
          isFirst = false;
        } else {
          keyValues += '\n';
        }
        keyValues += '* ' + x.keyValue;
      });
      this.allKeys = keyValues;
    } else if(this.selectedPreFilter.keyType === 1) {
      this.preFilterHierarchyMaps = this.selectedPreFilter.maps;
      this.preFilterHierarchyMaps.forEach(x => x.hierarchyLevel += 1);
    }

    this.selectedIndex = 1;
  }

  deleteFilterKey(preFilterKeyId: number) {
    this.selectedPreFilter = this.preFilterData.find(x => x.preFilterKeyId == preFilterKeyId);
    ConfirmDialogComponent
      .showDialog(this.dialog, 'Confirm Delete', 'Are you sure you want to delete this key & values?')
      .subscribe((confirmResult) => {
      if (confirmResult.ResultType === DialogResultType.Ok) {
        const key = this.preFilterData.find(x => x.preFilterKeyId == preFilterKeyId);
        this.preFilterService.preFilterInteractivesDeletePreFilterKey(key).subscribe(result => {
          if(result) {
            this.selectedPreFilter = null;
            this.preFilterName = '';
            this.preFilterDax = '';
            this.allKeys = '';
            this.loadPreFilters().then();
          }
        })
      }
    });
  }

  createNewKey() {
    this.selectedPreFilter = {
      preFilterKeyId: 0,
      name: '',
      daxName: '',
      interactId: this.data.interactiveId,
      keyType: 0
    };
    this.preFilterName = '';
    this.preFilterDax = '';
    this.preFilterType = 0;
    this.editMode = 'New';
    this.selectedIndex = 1;
    this.allKeys = '';
  }

  createNewFilterKey() {
    if (this.preFilterType === 0) {
      this.preFilterService.preFilterInteractivesAddFlatPreFilterKey({
        interactiveId: this.data.interactiveId,
        daxName: this.preFilterDax,
        name: this.preFilterName
      }).subscribe(result => {
        this.loadPreFilters().then();
        this.cancelChanges();
      })
    } else if (this.preFilterType === 1) {

      let finalizedMaps: PreFilterHierarchyMaps[] = [];

      this.hierarchyDaxKeys().forEach(x => finalizedMaps.push({
        preFilterHierarchyMapId: 0,
        preFilterKeyId: 0,
        daxName: x.daxName,
        hierarchyLevel: x.hierarchyLevel - 1
      }));

      this.preFilterService.preFilterInteractivesAddHierarchPreFilterKey({
        interactiveId: this.data.interactiveId,
        name: this.preFilterName,
        daxName: this.preFilterDax,
        maps: finalizedMaps
      }).subscribe(result => {
        this.loadPreFilters().then();
        this.cancelChanges();
      })
    } else if (this.preFilterType === 2) {
      this.preFilterService.preFilterInteractivesAddKeywordPreFilterKey({
        interactiveId: this.data.interactiveId,
        name: this.preFilterName,
        daxName: this.preFilterDax
      }).subscribe(result => {
        this.loadPreFilters().then();
        this.cancelChanges();
      })
    }
  }

  saveFilterKey() {
    let finalizedMaps: PreFilterHierarchyMaps[] = [];

    this.hierarchyDaxKeys().forEach(x => finalizedMaps.push({
      preFilterHierarchyMapId: 0,
      preFilterKeyId: 0,
      daxName: x.daxName,
      hierarchyLevel: x.hierarchyLevel - 1
    }));

    this.preFilterService.preFilterInteractivesUpdateFlatPreFilterKey({
      preFilterKeyId: this.selectedPreFilter.preFilterKeyId,
      name: this.preFilterName,
      daxName: this.preFilterDax,
      interactId: this.selectedPreFilter.interactId,
      maps: finalizedMaps,
      keyType: this.selectedPreFilter.keyType
    }).subscribe(result => {
      this.loadPreFilters().then();
      this.cancelChanges();
    })
  }

  cancelChanges() {
    this.preFilterName = '';
    this.preFilterDax = '';
    this.preFilterType = 0;
    this.allKeys = '';
    if (this.editMode == 'New') {
      this.selectedPreFilter = undefined;
    } else {
      this.editMode = 'New';
      this.selectedPreFilter = undefined;
    }

    this.selectedIndex = 0;
  }

  hierarchyDaxKeys(): PreFilterHierarchyMaps[] {
    return this.preFilterHierarchyMaps.sort((a, b) => a.hierarchyLevel - b.hierarchyLevel);
  }

  refreshFilterKeyValues() {
    this.preFilterService.preFilterInteractivesUpdatePreFilterKeyValues(this.selectedPreFilter.preFilterKeyId)
      .subscribe(result => {
      this.loadPreFilters().then(x => {
        this.selectFilterKey(this.selectedPreFilter.preFilterKeyId);
        MessageDialogComponent.showDialog(this.dialog, 'Success', 'Values Refreshed');
      });
    })
  }

  addHierarchyLevel() {
    this.preFilterHierarchyMaps.splice(this.hierarchyLevel - 1, 0, {
      preFilterKeyId: 0,
      preFilterHierarchyMapId: 0,
      daxName: this.hierarchyDaxField,
      hierarchyLevel: this.hierarchyLevel
    });

    for(let i = 0; i < this.preFilterHierarchyMaps.length; i++) {
      this.preFilterHierarchyMaps[i].hierarchyLevel = i + 1;
    }
  }

  removeHierarchy(index: number) {
    this.preFilterHierarchyMaps.splice(index, 1);
    for(let i = 0; i < this.preFilterHierarchyMaps.length; i++) {
      this.preFilterHierarchyMaps[i].hierarchyLevel = i + 1;
    }
  }
}
